import React, { Fragment, useEffect } from "react";
// import LogoImgs from '../../assets/images/main-logo.svg';
import LogoImgs from "../../assets/images/fely.png";
import SmallLog from "../../assets/images/smalllogo.svg";
import Logo from "../../assets/logo.svg";

import Swal from "sweetalert2";
import {
  FullName,
  clearStorage,
  getItemFromStorage,
  removeItemFromStorage,
  userPicUrl,
} from "../../utils/Helper";
import { Link, useLocation } from "react-router-dom";
import { BASE_URL, url } from "../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import {
  AdminDetailProfileAction,
  AdminLogoutAction,
} from "../../Redux/Action/AuthAction";
import ToastDefault from "../FieldComponets/Toast";
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";
import { FormattedMessage, useIntl } from "react-intl";
import LanguageSwitcher from "./LanguageSwitcher";

// const LogoImgs = require('../../assets/images/main-logo.png')
function Header() {
  const dispatch = useDispatch<any>();
  const intl = useIntl();
  const log_in = useSelector((state: any) => state.AdminLogInState);
  const DetailAdminProfile = useSelector(
    (state: any) => state.DetailAdminProfileState,
  );

  const handleLogout = async () => {
    Swal.fire({
      title: intl.formatMessage({ id: "are_you_sure" }),
      text: intl.formatMessage({ id: "are_you_logout" }),
      icon: "warning",
      // showCancelButton: true,
      confirmButtonColor: "#31CE36",
      cancelButtonColor: "#d33",
      showDenyButton: true,
      denyButtonText: intl.formatMessage({ id: "no" }),
      confirmButtonText: intl.formatMessage({ id: "yes" }),
    }).then(async (result) => {
      if (result.isConfirmed) {
        removeItemFromStorage("is_admin_login_token");
        await dispatch(AdminLogoutAction({}));
        window.location.href = BASE_URL + "/";
      }
    });
  };

  function capitalizeFirstLetter(str: string): string {
    if (!str) return ""; // Check if str is undefined or null
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const location = useLocation();

  useEffect(() => {
    Swal.close();
  }, [location.pathname]);

  return (
    <Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={SmallLog} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={Logo} alt="" height="50" />
                  {/* <h1>Horsely</h1> */}
                </span>
              </Link>

              <a href="index.html" className="logo logo-light">
                <span className="logo-sm">
                  {/* <img src="assets/images/logo-light.svg" alt="" height="22" /> */}
                </span>
                <span className="logo-lg">
                  {/* <img src="assets/images/logo-light.png" alt="" height="19" /> */}
                </span>
              </a>
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>

          <div className="d-flex align-items-center">
            <LanguageSwitcher className="me-2" />
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user"
                  src={userPicUrl(DetailAdminProfile?.data?.data?.profile_pic)}
                  alt=""
                />

                <span className="d-none d-xl-inline-block ms-1" key="t-henry">
                  {capitalizeFirstLetter(DetailAdminProfile?.data?.data?.name)}
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>

              <div className="dropdown-menu dropdown-menu-end">
                <Link to={url + "/edit-profile"} className="dropdown-item">
                  <i className="bx bx-user font-size-16 align-middle me-1"></i>
                  <span key="t-profile">
                    <FormattedMessage id="my_profile" />
                  </span>
                </Link>
                <div className="dropdown-divider"></div>

                <Link to={url + "/change-password"} className="dropdown-item">
                  <i className="bx bx-lock font-size-16 align-middle me-1"></i>{" "}
                  <span key="t-lock">
                    <FormattedMessage id="change_password" />
                  </span>
                </Link>
                <div className="dropdown-divider"></div>
                <button
                  onClick={handleLogout}
                  className="dropdown-item text-danger"
                >
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>{" "}
                  <span key="t-logout">
                    <FormattedMessage id="logout" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      <ToastDefault />
    </Fragment>
  );
}

export default Header;
